module.exports = __webpack_public_path__ + "static/media/special-needs-chair.e6f0c597.svg";